import React, { useEffect, useRef, useState } from "react";
import { Modal } from 'react-bootstrap';
import { OpportunityDetail, CreateOpportunityData, OpportunityCreate, OpportunityData } from '../../../../types/opportunity';
import { Link } from 'react-router-dom';
import { Funnel } from '../../../../types/funnels';
import OpportunityForm from '../OpportunityForm';
import { Offcanvas } from 'bootstrap';
interface ModalsProps {
    editingOpportunity: OpportunityDetail | null;
    isDeleting: boolean;
    showSuccessModal: boolean;
    showDeleteModal: boolean;
    showEditSuccessModal: boolean;
    opportunityId: number;
    funnels: Funnel[];
    selectedFunnel: Funnel | null;
    setSelectedFunnel: (funnel: Funnel | null) => void;
    onUpdate: (data: CreateOpportunityData) => Promise<void>;
    onDelete: () => Promise<void>;
    onCloseDelete: () => void;
    onCloseSuccess: () => void;
    onCloseEditSuccess: () => void;
}

interface UploadedFile {
    name: string;
    size: string;
    progress?: number;
}

// Funções existentes permanecem as mesmas
const convertCurrencyToNumber = (value: string): number => {
    const numericValue = value;
    return parseFloat(numericValue);
};

// Função convertToFormData
const convertToFormData = (opportunity: OpportunityDetail): OpportunityData => {
    return {
        id: opportunity.id.toString(),
        numero_contrato: opportunity.numero_contrato, // Novo campo
        titulo: opportunity.titulo,
        id_origem: opportunity.id_origem,
        nome_origem: opportunity.origem_nome,
        id_funil: opportunity.id_funil,
        nome_funil: opportunity.funil_nome,
        id_etapa: opportunity.id_etapa,
        nome_etapa: opportunity.etapa_nome,
        id_dono: opportunity.id_dono,
        nome_dono: opportunity.dono_nome,
        id_contato: opportunity.id_contato,
        nome_contato: opportunity.contato_nome,
        id_municipio: opportunity.id_municipio,
        nome_municipio: opportunity.municipio_nome,
        valor_licitacao: convertCurrencyToNumber(opportunity.valor_licitacao),
        data_licitacao: opportunity.data_licitacao,
        status: opportunity.status,
        id_conta: 2,
        probabilidade: opportunity.probabilidade || 50,
        uasb: opportunity.uasb || '', // Novo campo UASG
        tempo_entrega: opportunity.tempo_entrega || 'Sem informação', // Novo campo tempo de entrega
        url_site_externo: opportunity.url_site_externo || '' // Campo URL site externo
    };
};


const convertFormToApiData = (formData: OpportunityData): CreateOpportunityData => {
    return {
        id_conta: formData.id_conta,
        numero_contrato: formData.numero_contrato, // Novo campo
        titulo: formData.titulo,
        id_funil: Number(formData.id_funil),
        id_etapa: Number(formData.id_etapa),
        id_origem: Number(formData.id_origem),
        id_dono: Number(formData.id_dono),
        id_contato: Number(formData.id_contato),
        id_municipio: Number(formData.id_municipio),
        valor_licitacao: formData.valor_licitacao,
        status: formData.status,
        data_licitacao: formData.data_licitacao,
        probabilidade: formData.probabilidade,
        campos_personalizados: {},
        criado_por: 1,
        uasb: formData.uasb || '', // Novo campo UASG
        tempo_entrega: formData.tempo_entrega || 'Sem informação', // Novo campo tempo de entrega
        url_site_externo: formData.url_site_externo || '' // Campo URL site externo
    };
};

export const OpportunityDetailModals: React.FC<ModalsProps> = ({
    editingOpportunity,
    isDeleting,
    showSuccessModal,
    showDeleteModal,
    showEditSuccessModal,
    opportunityId,
    funnels,
    selectedFunnel,
    setSelectedFunnel,
    onUpdate,
    onDelete,
    onCloseDelete,
    onCloseSuccess,
    onCloseEditSuccess
}) => {
    const usersList = [
        { value: '1', label: 'Administrador Master' },
        { value: '3', label: 'Usuário Teste' },
    ];


    const handleFormSubmit = (formData: CreateOpportunityData) => {

        console.log('Enviando dados corretos atualização:', formData);

        onUpdate(formData);
    };


    return (
        <>
            {/* Modal de Edição (Offcanvas) */}
            <div
                className="offcanvas offcanvas-end offcanvas-large"
                tabIndex={-1}
                id="offcanvas_edit"
                data-bs-focus="false"
            >
                <div className="offcanvas-header border-bottom">
                    <h5 className="fw-semibold">Editar Oportunidade</h5>
                    <button
                        type="button"
                        className="btn-close custom-btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    >
                        <i className="ti ti-x" />
                    </button>
                </div>
                <div className="offcanvas-body">
                    {editingOpportunity && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <OpportunityForm
                                            isEditing={true}
                                            initialData={convertToFormData(editingOpportunity)}
                                            funnels={funnels}
                                            selectedFunnel={selectedFunnel}
                                            setSelectedFunnel={setSelectedFunnel}
                                            usersList={usersList}
                                            setOpenModal={() => { }}
                                            onClose={() => {
                                                const offcanvasElement = document.getElementById('offcanvas_edit');
                                                if (offcanvasElement) {
                                                    const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
                                                    if (offcanvasInstance) {
                                                        offcanvasInstance.hide();
                                                    }
                                                }
                                            }}
                                            onSubmit={handleFormSubmit}
                                            onOpportunityCreated={() => { }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de Confirmação de Exclusão */}
            <Modal show={showDeleteModal} onHide={onCloseDelete} centered>
                <div className="modal-body">
                    <div className="text-center">
                        <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                            <i className="ti ti-trash-x fs-36 text-danger" />
                        </div>
                        <h4 className="mb-2">Remover Oportunidade?</h4>
                        <p className="mb-0">
                            Tem certeza que deseja remover esta oportunidade?
                            Esta ação não poderá ser desfeita.
                        </p>
                        <div className="d-flex align-items-center justify-content-center mt-4">
                            <button
                                type="button"
                                className="btn btn-light me-2"
                                onClick={onCloseDelete}
                                disabled={isDeleting}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={onDelete}
                                disabled={isDeleting}
                            >
                                {isDeleting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Excluindo...
                                    </>
                                ) : (
                                    'Sim, Excluir'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Modal de Sucesso após Exclusão */}
            <Modal show={showSuccessModal} onHide={onCloseSuccess} centered>
                <div className="modal-body">
                    <div className="success-message text-center">
                        <div className="success-popup-icon bg-success-light">
                            <i className="ti ti-check-check fs-36 text-success" />
                        </div>
                        <h3>Oportunidade Excluída com Sucesso!</h3>
                        <p>A oportunidade foi removida permanentemente do sistema.</p>
                        <p className="mb-0">Você será redirecionado em instantes...</p>
                    </div>
                </div>
            </Modal>

            {/* Modal de Sucesso após Edição */}
            <Modal show={showEditSuccessModal} onHide={onCloseEditSuccess} centered>
                <div className="modal-body">
                    <div className="success-message text-center">
                        <div className="success-popup-icon bg-light-blue">
                            <i className="ti ti-medal" />
                        </div>
                        <h3>Oportunidade Atualizada com Sucesso</h3>
                        <p>A oportunidade foi atualizada com sucesso no sistema.</p>
                        <div className="col-lg-12 text-center modal-btn">
                            <button
                                className="btn btn-primary"
                                onClick={onCloseEditSuccess}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

        </>
    );
};